/**
 * « Comment ça marche ? » des SKILLCARDS — repliable, en tête de « Mes
 * SKILLCARDS ». Répond aux questions qu'on se pose AVANT de collectionner :
 * qu'est-ce qu'une carte (la méthode H·O·R·A), comment sa maîtrise monte (et
 * baisse), ce qui est gratuit et ce qui se débloque. Aucun prix codé en dur :
 * les prix viennent de la base et s'affichent sur la page d'achat.
 */

import { HORA_METHOD } from '@jeraisonne/db/cards';
import { ChevronDown } from 'lucide-react';

/** Teintes STATIQUES des 4 temps (Tailwind ne génère pas de classes dynamiques). */
const STEP_CLASSES: Record<string, string> = {
  H: 'bg-[#3b5bdb]',
  O: 'bg-[#2f9e44]',
  R: 'bg-[#f08c00]',
  A: 'bg-[#e03131]',
};

export function SkillcardExplainer({ defaultOpen = false }: { defaultOpen?: boolean }) {
  return (
    <details
      open={defaultOpen}
      className="border-ink-100 ocean:bg-white/5 group rounded-2xl border bg-white"
    >
      <summary className="text-ink-900 flex min-h-[2.75rem] cursor-pointer list-none items-center justify-between gap-2 px-4 py-2 font-semibold [&::-webkit-details-marker]:hidden">
        Comment ça marche ?
        <ChevronDown
          className="text-ink-400 h-4 w-4 shrink-0 transition-transform group-open:rotate-180"
          aria-hidden
        />
      </summary>
      <div className="space-y-4 px-4 pb-4">
        <div className="space-y-2">
          <p className="text-ink-700 text-sm">
            Une SKILLCARD = un outil de maths (méthode, théorème, formule). Elle t’apprend à
            raisonner en 4 temps :
          </p>
          <ol className="grid grid-cols-1 gap-2 sm:grid-cols-2">
            {HORA_METHOD.map((s) => (
              <li key={s.key} className="flex items-start gap-2">
                <span
                  aria-hidden
                  className={`font-display flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-extrabold text-white ${STEP_CLASSES[s.key] ?? 'bg-primary-500'}`}
                >
                  {s.key}
                </span>
                <span className="text-ink-700 text-sm">
                  <strong className="text-ink-900">{s.title}</strong> — {s.description}
                </span>
              </li>
            ))}
          </ol>
        </div>
        <ul className="text-ink-700 list-disc space-y-1.5 pl-5 text-sm">
          <li>
            Chaque bonne réponse à une question reliée à la carte lui rapporte de l’
            <strong>HORA</strong> (plus si la question est difficile).
          </li>
          <li>
            La <strong>maîtrise</strong> = ta réussite sur tes 50 dernières réponses. Sans
            entraînement, l’HORA baisse : retravaille les cartes marquées « À retravailler ».
          </li>
          <li>
            Chaque niveau d’une carte a un <strong>essai gratuit</strong> (1 question). Ensuite,
            débloque la carte seule, son pack ou tout ton programme : elles restent actives 1 an.
            L’abonnement JeRaisonne les inclut toutes.
          </li>
        </ul>
      </div>
    </details>
  );
}
